import { render, staticRenderFns } from "./OurBeliefsInnovativeSection.vue?vue&type=template&id=1b542e70"
import script from "./OurBeliefsInnovativeSection.vue?vue&type=script&lang=ts"
export * from "./OurBeliefsInnovativeSection.vue?vue&type=script&lang=ts"
import style0 from "./OurBeliefsInnovativeSection.vue?vue&type=style&index=0&id=1b542e70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports